module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Acknowledgements"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Author"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Author’s Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#ch1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Origins of the Emergency")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acclimatization and Evolution")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Upper Hand")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("‘The Best in Their Field’")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Race for 200")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Fight Continues")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 63
// module chunks = 0